<template>
  <AccessStateLayout
    description="Open the invite link from your teacher or organizer to enter the conference."
    eyebrow="Conference"
    test-id="welcome-access-state"
    title="Join your session"
  />
</template>

<script setup lang="ts">
import AccessStateLayout from './AccessStateLayout.vue';
</script>
